import React from 'react';
import { useParams } from 'react-router-dom';

import { useConfig } from '../../ConfigContext';
import { DbdGame } from './dbd-game/DbdGame';
import { ProvidePromotion } from '../promotion/PromotionContext';
import { GameIds } from './MyGames.model';
import { HoyGame } from './hoy-game/HoyGame';
import { MymGame } from './mym-game/MymGame';

import { PageLayout } from '../layout/PageLayout';
import { FlippinMisfitsGame } from './fm-game/FlippinMisfitsGame';
import { SophiaGame } from './sophia-game/SophiaGame';

interface GameSwitchProps {
  id: GameIds;
}

function GameSwitch({ id }: GameSwitchProps): JSX.Element | null {
  switch (id) {
    case GameIds.DBD:
      return <DbdGame />;
    case GameIds.MYM:
      return <MymGame />;
    case GameIds.HOY:
      return <HoyGame />;
    case GameIds.FM:
      return <FlippinMisfitsGame />;
    case GameIds.SOPHIA:
      return <SophiaGame />;
    default:
      return null;
  }
}

export function Game(): JSX.Element {
  const { gameId }: { gameId: GameIds } = useParams();
  const config = useConfig();

  return (
    <PageLayout>
      {config?.serverConfig.gamesConfig.find((gameConfig) => gameConfig.id === gameId) && (
        <ProvidePromotion rewardGameId={gameId}>
          <GameSwitch id={gameId} />
        </ProvidePromotion>
      )}
    </PageLayout>
  );
}
